module.exports = __webpack_public_path__ + "static/media/protecao-celular_new.d66b18a0.svg";